export const stati = [
  { step: 1, nome: 'Confermato', chiave: 'confermato' },
  { step: 2, nome: 'In spedizione', chiave: 'attesa_spedizione' },
  { step: 2, nome: 'Spedito parziale', chiave: 'spedito_parziale'},
  { step: 3, nome: 'Spedito', chiave: 'spedito' },
  { step: 4, nome: 'In consegna', chiave: 'in_consegna' },
  { step: 5, nome: 'Consegnato', chiave: 'consegnato' },
]